// React imports.
import React, { Component } from "react";

// App imports.
import Assessment1MainTable from "./Assessment1MainTable";
import Assessment2aMainTable from "./Assessment2aMainTable";
import Assessment2bMainTable from "./Assessment2bMainTable";
import Assessment3aMainTable from "./Assessment3aMainTable";
import Assessment3bMainTable from "./Assessment3bMainTable";
import TableLegendLeft from "./TableLegendLeft";

import { OverallAssessmentStepsEnum } from "../state";
import { OverallAssessmentSedsStatusEnum } from "../state";
import { Assessment2aStatusEnum } from "../state";
import { Assessment2bHHDataReceivedStatusEnum } from "../state";
import { Assessment1FuelStatusEnum } from "../state";
import { Assessment3aVendorAssignedStatusEnum } from "../state";
import { Assessment3bDataReceivedStatusEnum } from "../state";

const OverallAssessment = ({ state }) => (
    <div>
        {state.CurrentAssessementStepIndex == OverallAssessmentStepsEnum.ResultsOverview
        &&
        <div>
            <p><strong><u>Overview of Results</u></strong></p>
            <p>Based on your responses to the 4 screeners you should prioritize  
              the following detailed assessments:</p>
            <ul>
            {(state.OverallAssessmentFuelTypesStatus.NaturalGas.percentOfSedsStatus === Assessment1FuelStatusEnum.OverMax
              || state.OverallAssessmentFuelTypesStatus.NaturalGas.percentOfSedsStatus === Assessment1FuelStatusEnum.UnderMin
              ||state.OverallAssessmentFuelTypesStatus.FuelOil.percentOfSedsStatus === Assessment1FuelStatusEnum.OverMax
              || state.OverallAssessmentFuelTypesStatus.FuelOil.percentOfSedsStatus === Assessment1FuelStatusEnum.UnderMin
              ||state.OverallAssessmentFuelTypesStatus.Propane.percentOfSedsStatus === Assessment1FuelStatusEnum.OverMax
              ||state.OverallAssessmentFuelTypesStatus.Propane.percentOfSedsStatus === Assessment1FuelStatusEnum.UnderMin)
              &&<li>Assessment 1</li>
            }
            {(state.OverallAssessmentFuelTypesStatus.totalVendorStatus !== Assessment2aStatusEnum.MeetsMinRequirement5Plus
              &&state.OverallAssessmentFuelTypesStatus.totalVendorStatus !== Assessment2aStatusEnum.MeetsMinRequirementUnder5)
              &&<li>Assessment 2A</li>
            }      
            {(state.OverallAssessmentFuelTypesStatus.Electric.hhDataReceivedStatus2b === Assessment2bHHDataReceivedStatusEnum.NotMeetTarget 
              ||state.OverallAssessmentFuelTypesStatus.NaturalGas.hhDataReceivedStatus2b === Assessment2bHHDataReceivedStatusEnum.NotMeetTarget
              ||state.OverallAssessmentFuelTypesStatus.FuelOil.hhDataReceivedStatus2b === Assessment2bHHDataReceivedStatusEnum.NotMeetTarget
              ||state.OverallAssessmentFuelTypesStatus.Propane.hhDataReceivedStatus2b === Assessment2bHHDataReceivedStatusEnum.NotMeetTarget)
              &&<li>Assessment 2B</li>
            }
            {(state.OverallAssessmentFuelTypesStatus.Electric.vendorAssignmentStatus === Assessment3aVendorAssignedStatusEnum.Under95NotMeetTarget 
              ||state.OverallAssessmentFuelTypesStatus.NaturalGas.vendorAssignmentStatus === Assessment3aVendorAssignedStatusEnum.Under95NotMeetTarget
              ||state.OverallAssessmentFuelTypesStatus.FuelOil.vendorAssignmentStatus === Assessment3aVendorAssignedStatusEnum.Under95NotMeetTarget
              ||state.OverallAssessmentFuelTypesStatus.Propane.vendorAssignmentStatus === Assessment3aVendorAssignedStatusEnum.Under95NotMeetTarget)
              &&<li>Assessment 3A</li>
            }
            {(state.OverallAssessmentFuelTypesStatus.NaturalGas.hhDataReceivedStatus3b === Assessment3bDataReceivedStatusEnum.ElecticunderTarget
              ||state.OverallAssessmentFuelTypesStatus.FuelOil.hhDataReceivedStatus3b === Assessment3bDataReceivedStatusEnum.ElecticunderTarget
              ||state.OverallAssessmentFuelTypesStatus.Propane.hhDataReceivedStatus3b === Assessment3bDataReceivedStatusEnum.ElecticunderTarget
              ||state.OverallAssessmentFuelTypesStatus.NaturalGas.hhDataReceivedStatus3b === Assessment3bDataReceivedStatusEnum.MainHeatUnderTarget
              ||state.OverallAssessmentFuelTypesStatus.FuelOil.hhDataReceivedStatus3b === Assessment3bDataReceivedStatusEnum.MainHeatUnderTarget
              ||state.OverallAssessmentFuelTypesStatus.Propane.hhDataReceivedStatus3b === Assessment3bDataReceivedStatusEnum.MainHeatUnderTarget
              ||state.OverallAssessmentFuelTypesStatus.NaturalGas.hhDataReceivedStatus3b === Assessment3bDataReceivedStatusEnum.HhWithBothUnderTarget
              ||state.OverallAssessmentFuelTypesStatus.FuelOil.hhDataReceivedStatus3b === Assessment3bDataReceivedStatusEnum.HhWithBothUnderTarget
              ||state.OverallAssessmentFuelTypesStatus.Propane.hhDataReceivedStatus3b === Assessment3bDataReceivedStatusEnum.HhWithBothUnderTarget
              ||state.OverallAssessmentFuelTypesStatus.NaturalGas.hhDataReceivedStatus3b === Assessment3bDataReceivedStatusEnum.NeitherOverTarget
              ||state.OverallAssessmentFuelTypesStatus.FuelOil.hhDataReceivedStatus3b === Assessment3bDataReceivedStatusEnum.NeitherOverTarget
              ||state.OverallAssessmentFuelTypesStatus.Propane.hhDataReceivedStatus3b === Assessment3bDataReceivedStatusEnum.NeitherOverTarget)
              &&<li>Assessment 3B</li>
            }
            {(state.OverallAssessmentFuelTypesStatus.checkAgenciesCollectDataEveryClientFlag !== "Y"
                || state.OverallAssessmentFuelTypesStatus.checkVendorsSupplyDataEveryClientFlag !== "Y"
                || state.OverallAssessmentFuelTypesStatus.checksIdenfityErrorsFlag !== "Y"
                || state.OverallAssessmentFuelTypesStatus.processReviewFindingsFlag !== "Y"
                || state.OverallAssessmentFuelTypesStatus.processReviewChecksFlag !== "Y")
                &&
                <li>Assessment 4</li>
            }

            </ul>
            <p>Even if your data did not trigger any automatic errors, it may
              still be beneficial for you to work your way through each assessment
              to learn more about data reliability. </p>
        </div>
        }


        {state.CurrentAssessementStepIndex == OverallAssessmentStepsEnum.Assessment1EnterData &&
            <div>
                <p><strong><u>Assessment 1</u></strong></p>
                <p>Assessment 1 checks your low-income average electric expenditures  
                against reasonable estimates of what low-income households are spending on
                baseload electric in your state using data from the American Community
                Survey (ACS). </p>
                <span>If the PM data for the year you are trying to evaluate is  
                available in the LIHEAP Data Warehouse, then it has been auto  
                populated in the appropriate column below. If you are trying to  
                evaluate a year for which data has not yet been added to the Data  
                Warehouse, you will need to manually enter the <strong>calculated  
                average expenditures </strong>for each fuel type, which can be  
                found in <strong>Section V, Part B, Line 5 of your Performance  
                Data Form.</strong></span>
                <Assessment1MainTable  fieldChangeHandler={state.overallAssessmentFieldChangeHandler}
                                        holder={state.OverallAssessmentFuelTypesStatus}
                                        step={state.OverallAssessmentSteps[state.CurrentAssessementStepIndex]}
                                        state={state} />
                <TableLegendLeft />
                <br />
            </div>
        }

        {(state.CurrentAssessementStepIndex == OverallAssessmentStepsEnum.Assessment1Results
          || state.CurrentAssessementStepIndex == OverallAssessmentStepsEnum.ResultsOverview) &&
            <div>
            <p><strong><u>Assessment 1</u></strong></p>
            {state.CurrentAssessementStepIndex == OverallAssessmentStepsEnum.Assessment1Results
              &&
                <React.Fragment>
                    <p>Assessment 1 checks your low-income average electric expenditure data  
                    against a reasonable estimate of what low-income households are spending  
                    on baseload electricity in your state using data from the   
                    American Community Survey (ACS). </p>
                    <span>If the PM data for the year you are trying to evaluate is  
                    available in the LIHEAP Data Warehouse, then it has been auto  
                    populated in the appropriate column below. If you are trying to  
                    evaluate a year for which data has not yet been added to the Data  
                    Warehouse, you will need to manually enter the <strong>calculated  
                    average expenditures </strong>for each fuel type, which can be  
                    found in <strong>Section V, Part B, Line 5 of your Performance  
                    Data Form.</strong></span>

                </React.Fragment>
            }
            <Assessment1MainTable  fieldChangeHandler={state.overallAssessmentFieldChangeHandler}
                                    holder={state.OverallAssessmentFuelTypesStatus}
                                    step={state.OverallAssessmentSteps[state.CurrentAssessementStepIndex]}
                                    state={state} />
            <TableLegendLeft />
            <br />
            {((state.OverallAssessmentFuelTypesStatus.NaturalGas.percentOfSedsStatus === Assessment1FuelStatusEnum.InRangeNoIssues
                ||state.OverallAssessmentFuelTypesStatus.NaturalGas.percentOfSedsStatus === Assessment1FuelStatusEnum.ZeroAverageExpenditure)
              &&(state.OverallAssessmentFuelTypesStatus.FuelOil.percentOfSedsStatus === Assessment1FuelStatusEnum.InRangeNoIssues
                ||state.OverallAssessmentFuelTypesStatus.FuelOil.percentOfSedsStatus === Assessment1FuelStatusEnum.ZeroAverageExpenditure)
              &&(state.OverallAssessmentFuelTypesStatus.Propane.percentOfSedsStatus === Assessment1FuelStatusEnum.InRangeNoIssues
                ||state.OverallAssessmentFuelTypesStatus.Propane.percentOfSedsStatus === Assessment1FuelStatusEnum.ZeroAverageExpenditure))
                &&<p>
                    <strong>Looks good! No action needed!</strong><br/>
                    However, if you would like to explore this topic further you are welcome to conduct a full run-through of Assessment #1.
                </p>
            }
            {(state.OverallAssessmentFuelTypesStatus.NaturalGas.percentOfSedsStatus === Assessment1FuelStatusEnum.OverMax
              || state.OverallAssessmentFuelTypesStatus.NaturalGas.percentOfSedsStatus === Assessment1FuelStatusEnum.UnderMin
              ||state.OverallAssessmentFuelTypesStatus.FuelOil.percentOfSedsStatus === Assessment1FuelStatusEnum.OverMax
              || state.OverallAssessmentFuelTypesStatus.FuelOil.percentOfSedsStatus === Assessment1FuelStatusEnum.UnderMin
              ||state.OverallAssessmentFuelTypesStatus.Propane.percentOfSedsStatus === Assessment1FuelStatusEnum.OverMax
              ||state.OverallAssessmentFuelTypesStatus.Propane.percentOfSedsStatus === Assessment1FuelStatusEnum.UnderMin)
              &&<p>
                    <strong>Potential issue present! Follow-up required!</strong><br/>
                    Please conduct a full run-through of Assessment #1 to learn more about this potential issue and ways you can address it.
                </p>
            }
            {(state.OverallAssessmentFuelTypesStatus.NaturalGas.percentOfSedsStatus === Assessment1FuelStatusEnum.ZeroAverageExpenditure
                &&state.OverallAssessmentFuelTypesStatus.FuelOil.percentOfSedsStatus === Assessment1FuelStatusEnum.ZeroAverageExpenditure
                &&state.OverallAssessmentFuelTypesStatus.Propane.percentOfSedsStatus === Assessment1FuelStatusEnum.ZeroAverageExpenditure
            ) &&
              <p>
                  <strong>Potential issue present! Follow-up required!</strong><br/>
                  You reported zero average expenditures for all fuels.  You should verify that
                  this is correct and you may want to conduct a full run-through of Assessment #1.
              </p>
            }
            {((state.OverallAssessmentFuelTypesStatus.NaturalGas.percentOfSedsStatus === Assessment1FuelStatusEnum.NoSEDSData
                ||state.OverallAssessmentFuelTypesStatus.FuelOil.percentOfSedsStatus === Assessment1FuelStatusEnum.NoSEDSData
                ||state.OverallAssessmentFuelTypesStatus.Propane.percentOfSedsStatus === Assessment1FuelStatusEnum.NoSEDSData)
              && !(state.OverallAssessmentFuelTypesStatus.NaturalGas.percentOfSedsStatus === Assessment1FuelStatusEnum.OverMax
                || state.OverallAssessmentFuelTypesStatus.NaturalGas.percentOfSedsStatus === Assessment1FuelStatusEnum.UnderMin
                ||state.OverallAssessmentFuelTypesStatus.FuelOil.percentOfSedsStatus === Assessment1FuelStatusEnum.OverMax
                || state.OverallAssessmentFuelTypesStatus.FuelOil.percentOfSedsStatus === Assessment1FuelStatusEnum.UnderMin
                ||state.OverallAssessmentFuelTypesStatus.Propane.percentOfSedsStatus === Assessment1FuelStatusEnum.OverMax
                ||state.OverallAssessmentFuelTypesStatus.Propane.percentOfSedsStatus === Assessment1FuelStatusEnum.UnderMin)
              )
              &&
                <p>
                    <strong>N/A</strong><br/>
                    ACS data missing for one or more fuels.  Not able to evaluate all fuels.
                </p>

            }
        </div>
        }


        {state.CurrentAssessementStepIndex == OverallAssessmentStepsEnum.Assessment2AEnterData &&
        <div>
            <p><strong><u>Assessment 2A</u></strong></p>

            <p>
                Assessment 2A checks that you requested and received electric billing data from the required number of vendors of each vendor type.
            </p>
            <p>
                For each fuel type in the table below, please enter the total number of vendors serving LIHEAP clients in your state/territory, as well as the number of vendors from whom you requested electric billing data and the number who ultimately provided you with electric billing data. This information is NOT reported in your annual Performance Measures Form, so you will need to provide it from your own records.
            </p>
            <Assessment2aMainTable model={state.OverallAssessmentFuelTypesStatus}
                                    fieldChangeHandler={state.overallAssessmentFieldChangeHandlerHolder}
                                    step={state.OverallAssessmentSteps[state.CurrentAssessementStepIndex]} />
            <TableLegendLeft />
            <br />
        </div>
        }

        {(state.CurrentAssessementStepIndex == OverallAssessmentStepsEnum.Assessment2AResults
          || state.CurrentAssessementStepIndex == OverallAssessmentStepsEnum.ResultsOverview) &&
        <div>
            <p><strong><u>Assessment 2A</u></strong></p>
            {state.CurrentAssessementStepIndex == OverallAssessmentStepsEnum.Assessment2AResults
              &&
                <React.Fragment>
                    <p>
                        Assessment 2A checks that you requested and received electric billing data from the required
                        number of vendors of each vendor type.
                    </p>
                    <p>
                        For each fuel type in the table below, please enter the total number of vendors serving  
                        LIHEAP clients in your state/territory, as well as the number of vendors from whom you
                        requested electric billing data and the number who ultimately provided you with electric
                        billing data. This information is NOT reported in your annual Performance Measures Form,
                        so you will need to provide it from your own records.
                    </p>
                </React.Fragment>
            }
            
            <Assessment2aMainTable model={state.OverallAssessmentFuelTypesStatus}
                                    fieldChangeHandler={state.overallAssessmentFieldChangeHandlerHolder}
                                    step={state.OverallAssessmentSteps[state.CurrentAssessementStepIndex]} />
            <TableLegendLeft />
            <br />
            {(state.OverallAssessmentFuelTypesStatus.totalVendorStatus === Assessment2aStatusEnum.MeetsMinRequirement5Plus)
            &&
              <p>
                  <strong>Looks good! No action needed!</strong><br/>
                  However, if you would like to explore this topic further you are welcome to conduct a full run-through of Assessment #2A.
              </p>}
            {/*OutOfRange*/}
            {(state.OverallAssessmentFuelTypesStatus.totalVendorStatus !== Assessment2aStatusEnum.MeetsMinRequirement5Plus
              &&state.OverallAssessmentFuelTypesStatus.totalVendorStatus !== Assessment2aStatusEnum.MeetsMinRequirementUnder5)
            &&
              <p>
                  <strong>Potential issue present! Follow-up required!</strong><br/>
                  Please conduct a full run-through of Assessment #2A to learn more about this potential issue and ways you can address it.
              </p>}      

        </div>
        }

        {state.CurrentAssessementStepIndex == OverallAssessmentStepsEnum.Assessment2BEnterData &&
        <div>
            <p><strong><u>Assessment 2B</u></strong></p>
            <p>Assessment 2B checks that you requested and received electric billing data  
            for a sufficient number of clients that heat with each fuel type.</p> 
            <p>For each fuel type in the table below, please enter the total number  
            of LIHEAP assisted households in your state/territory from whom you  
            received electric billing data. </p> 
            <p>If the PM data for the year you are trying to evaluate is available  
            in the LIHEAP Data Warehouse, then the number of LIHEAP assisted households  
            in your state/territory has been auto populated in the appropriate column  
            below. If you are trying to evaluate a year for which data has not yet been  
            added to the Data Warehouse, you will need to manually enter the <strong>unduplicated  
            number of LIHEAP bill payment-assisted households </strong>for each fuel type,  
            which can be found in <strong>Section V, Part A of your Performance Data Form.</strong></p> 
            The number of households with electric billing data is NOT reported in your  
            annual Performance Measures Form, so you will need to provide it from your  
            own records. 
            <Assessment2bMainTable  fieldChangeHandler={state.overallAssessmentFieldChangeHandler}
                                    holder={state.OverallAssessmentFuelTypesStatus}
                                    step={state.OverallAssessmentSteps[state.CurrentAssessementStepIndex]}
                                    state={state} />
            <TableLegendLeft />
            <br />
        </div>
        }

        {(state.CurrentAssessementStepIndex == OverallAssessmentStepsEnum.Assessment2BResults
          || state.CurrentAssessementStepIndex == OverallAssessmentStepsEnum.ResultsOverview) &&
        <div>
            <p><strong><u>Assessment 2B</u></strong></p>

            {state.CurrentAssessementStepIndex == OverallAssessmentStepsEnum.Assessment2BResults
              &&
                <React.Fragment>
                    <p>Assessment 2B checks that you requested and received electric billing data  
                    for a sufficient number of clients that heat with each fuel type.</p> 
                    <p>For each fuel type in the table below, please enter the total number  
                    of LIHEAP assisted households in your state/territory from whom you  
                    received electric billing data. </p> 
                    <p>If the PM data for the year you are trying to evaluate is available  
                    in the LIHEAP Data Warehouse, then the number of LIHEAP assisted households  
                    in your state/territory has been auto populated in the appropriate column  
                    below. If you are trying to evaluate a year for which data has not yet been  
                    added to the Data Warehouse, you will need to manually enter the <strong>unduplicated  
                    number of LIHEAP bill payment-assisted households </strong>for each fuel type,  
                    which can be found in <strong>Section V, Part A of your Performance Data Form.</strong></p> 
                    The number of households with electric billing data is NOT reported in your  
                    annual Performance Measures Form, so you will need to provide it from your  
                    own records. 
                </React.Fragment>
            }

            <Assessment2bMainTable fieldChangeHandler={state.overallAssessmentFieldChangeHandler}
                                    holder={state.OverallAssessmentFuelTypesStatus}
                                    step={state.OverallAssessmentSteps[state.CurrentAssessementStepIndex]}
                                    state={state} />
            <TableLegendLeft />
            <br />
              {(((state.OverallAssessmentFuelTypesStatus.Electric.hhDataReceivedStatus2b === Assessment2bHHDataReceivedStatusEnum.OverTargetNoIssues
                  ||state.OverallAssessmentFuelTypesStatus.Electric.hhDataReceivedStatus2b === Assessment2bHHDataReceivedStatusEnum.NoHouseholdsServed)
              &&(state.OverallAssessmentFuelTypesStatus.NaturalGas.hhDataReceivedStatus2b === Assessment2bHHDataReceivedStatusEnum.OverTargetNoIssues
                  ||state.OverallAssessmentFuelTypesStatus.NaturalGas.hhDataReceivedStatus2b === Assessment2bHHDataReceivedStatusEnum.NoHouseholdsServed)
              &&(state.OverallAssessmentFuelTypesStatus.FuelOil.hhDataReceivedStatus2b === Assessment2bHHDataReceivedStatusEnum.OverTargetNoIssues
                  ||state.OverallAssessmentFuelTypesStatus.FuelOil.hhDataReceivedStatus2b === Assessment2bHHDataReceivedStatusEnum.NoHouseholdsServed)
              &&(state.OverallAssessmentFuelTypesStatus.Propane.hhDataReceivedStatus2b === Assessment2bHHDataReceivedStatusEnum.OverTargetNoIssues
                  ||state.OverallAssessmentFuelTypesStatus.Propane.hhDataReceivedStatus2b === Assessment2bHHDataReceivedStatusEnum.NoHouseholdsServed)
              )
              &&
              !(state.OverallAssessmentFuelTypesStatus.Electric.hhDataReceivedStatus2b === Assessment2bHHDataReceivedStatusEnum.NoHouseholdsServed
                  &&state.OverallAssessmentFuelTypesStatus.NaturalGas.hhDataReceivedStatus2b === Assessment2bHHDataReceivedStatusEnum.NoHouseholdsServed
                  &&state.OverallAssessmentFuelTypesStatus.FuelOil.hhDataReceivedStatus2b === Assessment2bHHDataReceivedStatusEnum.NoHouseholdsServed
                  &&state.OverallAssessmentFuelTypesStatus.Propane.hhDataReceivedStatus2b === Assessment2bHHDataReceivedStatusEnum.NoHouseholdsServed
              ))
              &&<p>
                  <strong>Looks good! No action needed!</strong><br/>
                  However, if you would like to explore this topic further you are welcome to conduct a full run-through of Assessment #2A.
              </p>
            }
            {(state.OverallAssessmentFuelTypesStatus.Electric.hhDataReceivedStatus2b === Assessment2bHHDataReceivedStatusEnum.NotMeetTarget 
              ||state.OverallAssessmentFuelTypesStatus.NaturalGas.hhDataReceivedStatus2b === Assessment2bHHDataReceivedStatusEnum.NotMeetTarget
              ||state.OverallAssessmentFuelTypesStatus.FuelOil.hhDataReceivedStatus2b === Assessment2bHHDataReceivedStatusEnum.NotMeetTarget
              ||state.OverallAssessmentFuelTypesStatus.Propane.hhDataReceivedStatus2b === Assessment2bHHDataReceivedStatusEnum.NotMeetTarget)
              &&<p>
                  <strong>Potential issue present! Follow-up required!</strong><br/>
                  Please conduct a full run-through of Assessment #2B to learn more about this potential issue and ways you can address it.
              </p>
            }
            {(state.OverallAssessmentFuelTypesStatus.Electric.hhDataReceivedStatus2b === Assessment2bHHDataReceivedStatusEnum.NoHouseholdsServed
              &&state.OverallAssessmentFuelTypesStatus.NaturalGas.hhDataReceivedStatus2b === Assessment2bHHDataReceivedStatusEnum.NoHouseholdsServed
              &&state.OverallAssessmentFuelTypesStatus.FuelOil.hhDataReceivedStatus2b === Assessment2bHHDataReceivedStatusEnum.NoHouseholdsServed
              &&state.OverallAssessmentFuelTypesStatus.Propane.hhDataReceivedStatus2b === Assessment2bHHDataReceivedStatusEnum.NoHouseholdsServed
              )
              &&<p>
                      <strong>N/A</strong><br/>
                      You did not serve households for any fuels.  Not able to evaluate all fuels.
                  </p>
            }

            {(state.OverallAssessmentFuelTypesStatus.Electric.hhDataReceivedStatus2b === Assessment2bHHDataReceivedStatusEnum.EntryError
              ||state.OverallAssessmentFuelTypesStatus.NaturalGas.hhDataReceivedStatus2b === Assessment2bHHDataReceivedStatusEnum.EntryError
              ||state.OverallAssessmentFuelTypesStatus.FuelOil.hhDataReceivedStatus2b === Assessment2bHHDataReceivedStatusEnum.EntryError
              ||state.OverallAssessmentFuelTypesStatus.Propane.hhDataReceivedStatus2b === Assessment2bHHDataReceivedStatusEnum.EntryError
              )
              &&<p>
                  <strong>Potential issue present! Follow-up required!</strong><br/>
                  There is a data entry error.
              </p>
            }
        </div>
        }
          
        {state.CurrentAssessementStepIndex == OverallAssessmentStepsEnum.Assessment3AEnterData &&
        <div>
            <p><strong><u>Assessment 3A</u></strong></p>
            <p>Assessment 3A checks whether you have an electric vendor and  
            account number on file for at least 95% of the LIHEAP-assisted  
            households you serve. </p>
            <p>For each fuel type in the table below, please enter the number  
            of LIHEAP households for whom you have an electric vendor and  
            account number on file. </p>
            <p>If the PM data for the year you are trying to evaluate  
            is available in the LIHEAP Data Warehouse, then the number of  
            LIHEAP assisted households in your state/territory has been  
            auto populated in the appropriate column below. If you are  
            trying to evaluate a year for which data has not yet been  
            added to the Data Warehouse, you will need to manually enter  
            the <strong>unduplicated number of LIHEAP bill payment-assisted  
            households </strong>for each fuel type, which can be found  
            in <strong>Section V, Part A of your Performance Data Form.</strong></p>
            <p>The number of households with an electric vendor and  
            account number on file is not reported in your PM form, so  
            you will need to report this information from your own  
            records.</p>
            <Assessment3aMainTable  fieldChangeHandler={state.overallAssessmentFieldChangeHandler}
                                    holder={state.OverallAssessmentFuelTypesStatus}
                                    step={state.OverallAssessmentSteps[state.CurrentAssessementStepIndex]}
                                    state={state} />
            <TableLegendLeft />
            <br />
        </div>
        }
  
        {(state.CurrentAssessementStepIndex == OverallAssessmentStepsEnum.Assessment3AResults
          || state.CurrentAssessementStepIndex == OverallAssessmentStepsEnum.ResultsOverview) &&
        <div>
            <p><strong><u>Assessment 3A</u></strong></p>
            {state.CurrentAssessementStepIndex == OverallAssessmentStepsEnum.Assessment3AResults
              &&
                <React.Fragment>
                    <p>Assessment 3A checks whether you have an electric vendor and  
                    account number on file for at least 95% of the LIHEAP-assisted  
                    households you serve. </p>

                    <p>For each fuel type in the table below, please enter the number  
                    of LIHEAP households for whom you have an electric vendor and  
                    account number on file. </p>

                    <p>If the PM data for the year you are trying to evaluate  
                    is available in the LIHEAP Data Warehouse, then the number of  
                    LIHEAP assisted households in your state/territory has been  
                    auto populated in the appropriate column below. If you are  
                    trying to evaluate a year for which data has not yet been  
                    added to the Data Warehouse, you will need to manually enter  
                    the <strong>unduplicated number of LIHEAP bill payment-assisted  
                    households </strong>for each fuel type, which can be found  
                    in <strong>Section V, Part A of your Performance Data Form.</strong></p>

                    <p>The number of households with an electric vendor and  
                    account number on file is not reported in your PM form, so  
                    you will need to report this information from your own  
                    records.</p>

                </React.Fragment>
            }

            <Assessment3aMainTable  fieldChangeHandler={state.overallAssessmentFieldChangeHandler}
                                    holder={state.OverallAssessmentFuelTypesStatus}
                                    step={state.OverallAssessmentSteps[state.CurrentAssessementStepIndex]}
                                    state={state} />
              
            <TableLegendLeft />
            <br />
            {((state.OverallAssessmentFuelTypesStatus.Electric.vendorAssignmentStatus === Assessment3aVendorAssignedStatusEnum.Over95NoIssues
                ||state.OverallAssessmentFuelTypesStatus.Electric.vendorAssignmentStatus === Assessment3aVendorAssignedStatusEnum.NoHouseholdsServed)
              &&(state.OverallAssessmentFuelTypesStatus.NaturalGas.vendorAssignmentStatus === Assessment3aVendorAssignedStatusEnum.Over95NoIssues
                  ||state.OverallAssessmentFuelTypesStatus.NaturalGas.vendorAssignmentStatus === Assessment3aVendorAssignedStatusEnum.NoHouseholdsServed)
              &&(state.OverallAssessmentFuelTypesStatus.FuelOil.vendorAssignmentStatus === Assessment3aVendorAssignedStatusEnum.Over95NoIssues
                  ||state.OverallAssessmentFuelTypesStatus.FuelOil.vendorAssignmentStatus === Assessment3aVendorAssignedStatusEnum.NoHouseholdsServed)
              &&(state.OverallAssessmentFuelTypesStatus.Propane.vendorAssignmentStatus === Assessment3aVendorAssignedStatusEnum.Over95NoIssues
                  ||state.OverallAssessmentFuelTypesStatus.Propane.vendorAssignmentStatus === Assessment3aVendorAssignedStatusEnum.NoHouseholdsServed))
              &&<p>
                  <strong>Looks good! No action needed!</strong><br/>
                  However, if you would like to explore this topic further you are welcome to conduct a full run-through of Assessment #3A.
              </p>
            }
            {(state.OverallAssessmentFuelTypesStatus.Electric.vendorAssignmentStatus === Assessment3aVendorAssignedStatusEnum.Under95NotMeetTarget 
              ||state.OverallAssessmentFuelTypesStatus.NaturalGas.vendorAssignmentStatus === Assessment3aVendorAssignedStatusEnum.Under95NotMeetTarget
              ||state.OverallAssessmentFuelTypesStatus.FuelOil.vendorAssignmentStatus === Assessment3aVendorAssignedStatusEnum.Under95NotMeetTarget
              ||state.OverallAssessmentFuelTypesStatus.Propane.vendorAssignmentStatus === Assessment3aVendorAssignedStatusEnum.Under95NotMeetTarget)
              &&<p>
                  <strong>Potential issue present! Follow-up required!</strong><br/>
                  Please conduct a full run-through of Assessment #3A to learn more about this potential issue and ways you can address it.
              </p>
            }
            {(state.OverallAssessmentFuelTypesStatus.Electric.vendorAssignmentStatus === Assessment3aVendorAssignedStatusEnum.NoHouseholdsServed
              &&state.OverallAssessmentFuelTypesStatus.NaturalGas.vendorAssignmentStatus === Assessment3aVendorAssignedStatusEnum.NoHouseholdsServed
              &&state.OverallAssessmentFuelTypesStatus.FuelOil.vendorAssignmentStatus === Assessment3aVendorAssignedStatusEnum.NoHouseholdsServed
              &&state.OverallAssessmentFuelTypesStatus.Propane.vendorAssignmentStatus === Assessment3aVendorAssignedStatusEnum.NoHouseholdsServed
              )
              &&<p>
                      <strong>N/A</strong><br/>
                      You did not serve households for any fuels.  Not able to evaluate all fuels.
                  </p>
            }
            {(state.OverallAssessmentFuelTypesStatus.Electric.vendorAssignmentStatus === Assessment3aVendorAssignedStatusEnum.EntryError
              ||state.OverallAssessmentFuelTypesStatus.NaturalGas.vendorAssignmentStatus === Assessment3aVendorAssignedStatusEnum.EntryError
              ||state.OverallAssessmentFuelTypesStatus.FuelOil.vendorAssignmentStatus === Assessment3aVendorAssignedStatusEnum.EntryError
              ||state.OverallAssessmentFuelTypesStatus.Propane.vendorAssignmentStatus === Assessment3aVendorAssignedStatusEnum.EntryError
              )
              &&<p>
                  <strong>Potential issue present! Follow-up required!</strong><br/>
                  There is a data entry error.
              </p>
            }
        </div>
        }

          
        {state.CurrentAssessementStepIndex == OverallAssessmentStepsEnum.Assessment3BEnterData &&
        <div>
            <p><strong><u>Assessment 3B</u></strong></p>

            <p>Assessment 3B checks the number of LIHEAP recipients from whom  
            electric and/or main heating fuel billing data was received against  
            the total number of LIHEAP recipients. &nbsp;</p>
            <p>Please enter the number of households for whom you received  
            12 consecutive months of main heating expenditure data in the  
            table below. Please note that your Performance Data Form asks  
            for the number of households for whom 12 months of consecutive  
            billing data were collected for <em>both </em>main heating fuel  
            and electricity. However, for the purposes of this assessment  
            we are concerned with the number of households for whom main  
            heating fuel data was collected <em>regardless</em> of whether  
            electric data was also collected, so you will need to report  
            this information from your own records.</p>
            <p>Please also enter the number of households from whom you  
            received <em>both</em> 12 consecutive months of expenditure  
            data for <em>both</em> main heating and electric baseload.</p>
            <p> If the PM data for the year you are trying to evaluate is  
            available in the LIHEAP Data Warehouse, then this column has  
            been auto populated in the appropriate column below. If you  
            are trying to evaluate a year for which data has not yet been  
            added to the Data Warehouse, you will need to manually enter  
            the <strong>number of households with data </strong>for each  
            fuel type, which can be found in <strong>Section V, Part A of  
            your Performance Data Form.</strong></p>
            <Assessment3bMainTable  fieldChangeHandler={state.overallAssessmentFieldChangeHandler}
                                    holder={state.OverallAssessmentFuelTypesStatus}
                                    step={state.OverallAssessmentSteps[state.CurrentAssessementStepIndex]}
                                    state={state} />
            <TableLegendLeft />
            <br />
        </div>
        }

        {(state.CurrentAssessementStepIndex == OverallAssessmentStepsEnum.Assessment3BResults
          || state.CurrentAssessementStepIndex == OverallAssessmentStepsEnum.ResultsOverview) &&
        <div>
            <p><strong><u>Assessment 3B</u></strong></p>
            {state.CurrentAssessementStepIndex == OverallAssessmentStepsEnum.Assessment3BResults
              &&
                <React.Fragment>
                    <p>Assessment 3B checks the number of LIHEAP recipients from whom  
                    electric and/or main heating fuel billing data was received against  
                    the total number of LIHEAP recipients. &nbsp;</p>
                    <p>Please enter the number of households for whom you received  
                    12 consecutive months of main heating expenditure data in the  
                    table below. Please note that your Performance Data Form asks  
                    for the number of households for whom 12 months of consecutive  
                    billing data were collected for <em>both </em>main heating fuel  
                    and electricity. However, for the purposes of this assessment  
                    we are concerned with the number of households for whom main  
                    heating fuel data was collected <em>regardless</em> of whether  
                    electric data was also collected, so you will need to report  
                    this information from your own records.</p>
                    <p>Please also enter the number of households from whom you  
                    received <em>both</em> 12 consecutive months of expenditure  
                    data for <em>both</em> main heating and electric baseload.</p>
                    <p> If the PM data for the year you are trying to evaluate is  
                    available in the LIHEAP Data Warehouse, then this column has  
                    been auto populated in the appropriate column below. If you  
                    are trying to evaluate a year for which data has not yet been  
                    added to the Data Warehouse, you will need to manually enter  
                    the <strong>number of households with data </strong>for each  
                    fuel type, which can be found in <strong>Section V, Part A of  
                    your Performance Data Form.</strong></p>

                </React.Fragment>
            }
            <Assessment3bMainTable  fieldChangeHandler={state.overallAssessmentFieldChangeHandler}
                                    holder={state.OverallAssessmentFuelTypesStatus}
                                    step={state.OverallAssessmentSteps[state.CurrentAssessementStepIndex]}
                                    state={state} />
            <TableLegendLeft />


            {((state.OverallAssessmentFuelTypesStatus.NaturalGas.hhDataReceivedStatus3b === Assessment3bDataReceivedStatusEnum.OverTargetNoIssues
                ||state.OverallAssessmentFuelTypesStatus.NaturalGas.hhDataReceivedStatus3b === Assessment3bDataReceivedStatusEnum.NoHouseholdsServed)
              &&(state.OverallAssessmentFuelTypesStatus.FuelOil.hhDataReceivedStatus3b === Assessment3bDataReceivedStatusEnum.OverTargetNoIssues
                ||state.OverallAssessmentFuelTypesStatus.FuelOil.hhDataReceivedStatus3b === Assessment3bDataReceivedStatusEnum.NoHouseholdsServed)
              &&(state.OverallAssessmentFuelTypesStatus.Propane.hhDataReceivedStatus3b === Assessment3bDataReceivedStatusEnum.OverTargetNoIssues
                ||state.OverallAssessmentFuelTypesStatus.Propane.hhDataReceivedStatus3b === Assessment3bDataReceivedStatusEnum.NoHouseholdsServed)
              &&!(state.OverallAssessmentFuelTypesStatus.NaturalGas.hhDataReceivedStatus3b === Assessment3bDataReceivedStatusEnum.NoHouseholdsServed
                  &&state.OverallAssessmentFuelTypesStatus.FuelOil.hhDataReceivedStatus3b === Assessment3bDataReceivedStatusEnum.NoHouseholdsServed
                  &&state.OverallAssessmentFuelTypesStatus.Propane.hhDataReceivedStatus3b === Assessment3bDataReceivedStatusEnum.NoHouseholdsServed)
              )
              &&<p>
                  <strong>Looks good! No action needed!</strong><br/>
                  However, if you would like to explore this topic further you are welcome to conduct a full run-through of Assessment #3B.
              </p>
            }
            {(state.OverallAssessmentFuelTypesStatus.NaturalGas.hhDataReceivedStatus3b === Assessment3bDataReceivedStatusEnum.ElecticunderTarget
              ||state.OverallAssessmentFuelTypesStatus.FuelOil.hhDataReceivedStatus3b === Assessment3bDataReceivedStatusEnum.ElecticunderTarget
              ||state.OverallAssessmentFuelTypesStatus.Propane.hhDataReceivedStatus3b === Assessment3bDataReceivedStatusEnum.ElecticunderTarget
              ||state.OverallAssessmentFuelTypesStatus.NaturalGas.hhDataReceivedStatus3b === Assessment3bDataReceivedStatusEnum.MainHeatUnderTarget
              ||state.OverallAssessmentFuelTypesStatus.FuelOil.hhDataReceivedStatus3b === Assessment3bDataReceivedStatusEnum.MainHeatUnderTarget
              ||state.OverallAssessmentFuelTypesStatus.Propane.hhDataReceivedStatus3b === Assessment3bDataReceivedStatusEnum.MainHeatUnderTarget
              ||state.OverallAssessmentFuelTypesStatus.NaturalGas.hhDataReceivedStatus3b === Assessment3bDataReceivedStatusEnum.HhWithBothUnderTarget
              ||state.OverallAssessmentFuelTypesStatus.FuelOil.hhDataReceivedStatus3b === Assessment3bDataReceivedStatusEnum.HhWithBothUnderTarget
              ||state.OverallAssessmentFuelTypesStatus.Propane.hhDataReceivedStatus3b === Assessment3bDataReceivedStatusEnum.HhWithBothUnderTarget
              ||state.OverallAssessmentFuelTypesStatus.NaturalGas.hhDataReceivedStatus3b === Assessment3bDataReceivedStatusEnum.NeitherOverTarget
              ||state.OverallAssessmentFuelTypesStatus.FuelOil.hhDataReceivedStatus3b === Assessment3bDataReceivedStatusEnum.NeitherOverTarget
              ||state.OverallAssessmentFuelTypesStatus.Propane.hhDataReceivedStatus3b === Assessment3bDataReceivedStatusEnum.NeitherOverTarget)
              &&<p>
                  <strong>Potential issue present! Follow-up required!</strong><br/>
                  Please conduct a full run-through of Assessment #3B to learn more about this potential issue and ways you can address it.
              </p>
            }
            {(state.OverallAssessmentFuelTypesStatus.NaturalGas.hhDataReceivedStatus3b === Assessment3bDataReceivedStatusEnum.NoHouseholdsServed
              &&state.OverallAssessmentFuelTypesStatus.FuelOil.hhDataReceivedStatus3b === Assessment3bDataReceivedStatusEnum.NoHouseholdsServed
              &&state.OverallAssessmentFuelTypesStatus.Propane.hhDataReceivedStatus3b === Assessment3bDataReceivedStatusEnum.NoHouseholdsServed
              )
              &&<p>
                      <strong>N/A</strong><br/>
                      You did not serve households for any fuels.  Not able to evaluate all fuels.
                  </p>
            }
            {(state.OverallAssessmentFuelTypesStatus.NaturalGas.hhDataReceivedStatus3b === Assessment3bDataReceivedStatusEnum.EntryError
              ||state.OverallAssessmentFuelTypesStatus.FuelOil.hhDataReceivedStatus3b === Assessment3bDataReceivedStatusEnum.EntryError
              ||state.OverallAssessmentFuelTypesStatus.Propane.hhDataReceivedStatus3b === Assessment3bDataReceivedStatusEnum.EntryError
              )
              &&<p>
                  <strong>Potential issue present! Follow-up required!</strong><br/>
                  There is a data entry error.
              </p>
            }
        </div>
        }

        {(state.CurrentAssessementStepIndex == OverallAssessmentStepsEnum.Assessment4EnterData
          || state.CurrentAssessementStepIndex == OverallAssessmentStepsEnum.Assessment4Results
          || state.CurrentAssessementStepIndex == OverallAssessmentStepsEnum.ResultsOverview)
         &&<div>
            <p><strong><u>Assessment 4</u></strong></p>
            {(state.CurrentAssessementStepIndex == OverallAssessmentStepsEnum.Assessment4EnterData
              || state.CurrentAssessementStepIndex == OverallAssessmentStepsEnum.Assessment4Results)
                &&<p>
                    Assessment #4 helps you evaluate the data checking routines that you have in place. Please answer the questions below.
                </p>
            }

            <br />
            <ol start={1}>
                {/*checkAgenciesCollectDataEveryClient*/}
                <li>
                      Do you have checks in place to examine whether agencies are collecting electric vendor information for every client?
                      <br/>
                      <label>
                          <input type="radio"
                              name="checkAgenciesCollectDataEveryClientFlag"
                              id="checkAgenciesCollectDataEveryClientFlag_true"
                              value="Y"
                              checked={state.OverallAssessmentFuelTypesStatus.checkAgenciesCollectDataEveryClientFlag === "Y"}
                              onChange={(changeEvent) => state.overallAssessmentFieldChangeHandlerHolder(changeEvent, state.OverallAssessmentFuelTypesStatus)}
                          />
                          <span>Yes</span>
                      </label>
                      &nbsp;&nbsp;
                      <label>
                          <input type="radio"
                              name="checkAgenciesCollectDataEveryClientFlag"
                              id="checkAgenciesCollectDataEveryClientFlag_false"
                              value="N"
                              checked={state.OverallAssessmentFuelTypesStatus.checkAgenciesCollectDataEveryClientFlag === "N"}
                              onChange={(changeEvent) => state.overallAssessmentFieldChangeHandlerHolder(changeEvent, state.OverallAssessmentFuelTypesStatus)}
                          />
                          <span>No</span>
                      </label>
                      &nbsp;&nbsp;
                      <label>
                          <input type="radio"
                              name="checkAgenciesCollectDataEveryClientFlag"
                              id="checkAgenciesCollectDataEveryClientFlag_dk"
                              value="U"
                              checked={state.OverallAssessmentFuelTypesStatus.checkAgenciesCollectDataEveryClientFlag === "U"}
                              onChange={(changeEvent) => state.overallAssessmentFieldChangeHandlerHolder(changeEvent, state.OverallAssessmentFuelTypesStatus)}
                          />
                          <span>Don't Know</span>
                      </label>
                      <br/ >
                      {state.OverallAssessmentFuelTypesStatus.checkAgenciesCollectDataEveryClientFlag === "Y"
                        && <span>
                            <strong>Good!  </strong>   
                          </span>
                        }
                      {(state.OverallAssessmentFuelTypesStatus.checkAgenciesCollectDataEveryClientFlag === "N"
                        ||state.OverallAssessmentFuelTypesStatus.checkAgenciesCollectDataEveryClientFlag === "U")
                        &&
                          <span>
                            <strong>Requires followup.</strong>&nbsp;
                          </span>}
                      <br/><br/>
                  </li>
                {/*checkVendorsSupplyDataEveryClient*/}
                <li>
                      Do you have checks in place to examine whether vendors are supplying complete electric billing information for every client? 
                      <br/>
                      <label>
                          <input type="radio"
                              name="checkVendorsSupplyDataEveryClientFlag"
                              id="checkVendorsSupplyDataEveryClientFlag_true"
                              value="Y"
                              checked={state.OverallAssessmentFuelTypesStatus.checkVendorsSupplyDataEveryClientFlag === "Y"}
                              onChange={(changeEvent) => state.overallAssessmentFieldChangeHandlerHolder(changeEvent, state.OverallAssessmentFuelTypesStatus)}
                          />
                          <span>Yes</span>
                      </label>
                      &nbsp;&nbsp;
                      <label>
                          <input type="radio"
                              name="checkVendorsSupplyDataEveryClientFlag"
                              id="checkVendorsSupplyDataEveryClientFlag_false"
                              value="N"
                              checked={state.OverallAssessmentFuelTypesStatus.checkVendorsSupplyDataEveryClientFlag === "N"}
                              onChange={(changeEvent) => state.overallAssessmentFieldChangeHandlerHolder(changeEvent, state.OverallAssessmentFuelTypesStatus)}
                          />
                          <span>No</span>
                      </label>
                      &nbsp;&nbsp;
                      <label>
                          <input type="radio"
                              name="checkVendorsSupplyDataEveryClientFlag"
                              id="checkVendorsSupplyDataEveryClientFlag_dk"
                              value="U"
                              checked={state.OverallAssessmentFuelTypesStatus.checkVendorsSupplyDataEveryClientFlag === "U"}
                              onChange={(changeEvent) => state.overallAssessmentFieldChangeHandlerHolder(changeEvent, state.OverallAssessmentFuelTypesStatus)}
                          />
                          <span>Don't Know</span>
                      </label>
                      <br/ >
                      {state.OverallAssessmentFuelTypesStatus.checkVendorsSupplyDataEveryClientFlag === "Y"
                        && <span>
                            <strong>Good!  </strong>   
                          </span>
                        }
                      {(state.OverallAssessmentFuelTypesStatus.checkVendorsSupplyDataEveryClientFlag === "N"
                        ||state.OverallAssessmentFuelTypesStatus.checkVendorsSupplyDataEveryClientFlag === "U")
                        &&
                          <span>
                            <strong>Requires followup.</strong>&nbsp;
                          </span>}
                      <br/><br/>
                  </li>

                {/*checksIdenfityErrors*/}
                <li>
                      Do you have checks in place to review the data submitted by vendors and identify potential errors? 
                      <br/>
                      <label>
                          <input type="radio"
                              name="checksIdenfityErrorsFlag"
                              id="checksIdenfityErrorsFlag_true"
                              value="Y"
                              checked={state.OverallAssessmentFuelTypesStatus.checksIdenfityErrorsFlag === "Y"}
                              onChange={(changeEvent) => state.overallAssessmentFieldChangeHandlerHolder(changeEvent, state.OverallAssessmentFuelTypesStatus)}
                          />
                          <span>Yes</span>
                      </label>
                      &nbsp;&nbsp;
                      <label>
                          <input type="radio"
                              name="checksIdenfityErrorsFlag"
                              id="checksIdenfityErrorsFlag_false"
                              value="N"
                              checked={state.OverallAssessmentFuelTypesStatus.checksIdenfityErrorsFlag === "N"}
                              onChange={(changeEvent) => state.overallAssessmentFieldChangeHandlerHolder(changeEvent, state.OverallAssessmentFuelTypesStatus)}
                          />
                          <span>No</span>
                      </label>
                      &nbsp;&nbsp;
                      <label>
                          <input type="radio"
                              name="checksIdenfityErrorsFlag"
                              id="checksIdenfityErrorsFlag_dk"
                              value="U"
                              checked={state.OverallAssessmentFuelTypesStatus.checksIdenfityErrorsFlag === "U"}
                              onChange={(changeEvent) => state.overallAssessmentFieldChangeHandlerHolder(changeEvent, state.OverallAssessmentFuelTypesStatus)}
                          />
                          <span>Don't Know</span>
                      </label>
                      <br/ >
                      {state.OverallAssessmentFuelTypesStatus.checksIdenfityErrorsFlag === "Y"
                        && <span>
                            <strong>Good!  </strong>   
                          </span>
                        }
                      {(state.OverallAssessmentFuelTypesStatus.checksIdenfityErrorsFlag === "N"
                        ||state.OverallAssessmentFuelTypesStatus.checksIdenfityErrorsFlag === "U")
                        &&
                          <span>
                            <strong>Requires followup.</strong>&nbsp;
                          </span>}
                      <br/><br/>
                  </li>

                {/*processReviewFindings*/}
                <li>
                      Do you have procedures in place for reviewing and resolving the findings from your reliability checks?
                      <br/>
                      <label>
                          <input type="radio"
                              name="processReviewFindingsFlag"
                              id="processReviewFindingsFlag_true"
                              value="Y"
                              checked={state.OverallAssessmentFuelTypesStatus.processReviewFindingsFlag === "Y"}
                              onChange={(changeEvent) => state.overallAssessmentFieldChangeHandlerHolder(changeEvent, state.OverallAssessmentFuelTypesStatus)}
                          />
                          <span>Yes</span>
                      </label>
                      &nbsp;&nbsp;
                      <label>
                          <input type="radio"
                              name="processReviewFindingsFlag"
                              id="processReviewFindingsFlag_false"
                              value="N"
                              checked={state.OverallAssessmentFuelTypesStatus.processReviewFindingsFlag === "N"}
                              onChange={(changeEvent) => state.overallAssessmentFieldChangeHandlerHolder(changeEvent, state.OverallAssessmentFuelTypesStatus)}
                          />
                          <span>No</span>
                      </label>
                      &nbsp;&nbsp;
                      <label>
                          <input type="radio"
                              name="processReviewFindingsFlag"
                              id="processReviewFindingsFlag_dk"
                              value="U"
                              checked={state.OverallAssessmentFuelTypesStatus.processReviewFindingsFlag === "U"}
                              onChange={(changeEvent) => state.overallAssessmentFieldChangeHandlerHolder(changeEvent, state.OverallAssessmentFuelTypesStatus)}
                          />
                          <span>Don't Know</span>
                      </label>
                      <br/ >
                      {state.OverallAssessmentFuelTypesStatus.processReviewFindingsFlag === "Y"
                        && <span>
                            <strong>Good!  </strong>   
                          </span>
                        }
                      {(state.OverallAssessmentFuelTypesStatus.processReviewFindingsFlag === "N"
                        ||state.OverallAssessmentFuelTypesStatus.processReviewFindingsFlag === "U")
                        &&
                          <span>
                            <strong>Requires followup.</strong>&nbsp;
                          </span>}
                      <br/><br/>
                  </li>

                {/*processReviewChecks*/}
                <li>
                      Do you have procedures in place for assessing the effectiveness of your checks and making changes when necessary?
                      <br/>
                      <label>
                          <input type="radio"
                              name="processReviewChecksFlag"
                              id="processReviewChecksFlag_true"
                              value="Y"
                              checked={state.OverallAssessmentFuelTypesStatus.processReviewChecksFlag === "Y"}
                              onChange={(changeEvent) => state.overallAssessmentFieldChangeHandlerHolder(changeEvent, state.OverallAssessmentFuelTypesStatus)}
                          />
                          <span>Yes</span>
                      </label>
                      &nbsp;&nbsp;
                      <label>
                          <input type="radio"
                              name="processReviewChecksFlag"
                              id="processReviewChecksFlag_false"
                              value="N"
                              checked={state.OverallAssessmentFuelTypesStatus.processReviewChecksFlag === "N"}
                              onChange={(changeEvent) => state.overallAssessmentFieldChangeHandlerHolder(changeEvent, state.OverallAssessmentFuelTypesStatus)}
                          />
                          <span>No</span>
                      </label>
                      &nbsp;&nbsp;
                      <label>
                          <input type="radio"
                              name="processReviewChecksFlag"
                              id="processReviewChecksFlag_dk"
                              value="U"
                              checked={state.OverallAssessmentFuelTypesStatus.processReviewChecksFlag === "U"}
                              onChange={(changeEvent) => state.overallAssessmentFieldChangeHandlerHolder(changeEvent, state.OverallAssessmentFuelTypesStatus)}
                          />
                          <span>Don't Know</span>
                      </label>
                      <br/ >
                      {state.OverallAssessmentFuelTypesStatus.processReviewChecksFlag === "Y"
                        && <span>
                            <strong>Good!  </strong>   
                          </span>
                        }
                      {(state.OverallAssessmentFuelTypesStatus.processReviewChecksFlag === "N"
                        ||state.OverallAssessmentFuelTypesStatus.processReviewChecksFlag === "U")
                        &&
                          <span>
                            <strong>Requires followup.</strong>&nbsp;
                          </span>}
                      <br/><br/>
                  </li>            
            </ol>
            {((state.CurrentAssessementStepIndex == OverallAssessmentStepsEnum.Assessment4Results
              || state.CurrentAssessementStepIndex == OverallAssessmentStepsEnum.ResultsOverview)
                &&state.OverallAssessmentFuelTypesStatus.checkAgenciesCollectDataEveryClientFlag == "Y"
                && state.OverallAssessmentFuelTypesStatus.checkVendorsSupplyDataEveryClientFlag == "Y"
                && state.OverallAssessmentFuelTypesStatus.checksIdenfityErrorsFlag == "Y"
                && state.OverallAssessmentFuelTypesStatus.processReviewFindingsFlag == "Y"
                && state.OverallAssessmentFuelTypesStatus.processReviewChecksFlag == "Y")
                &&
                <p>
                    <strong>Looks good! No action needed!</strong><br/>
                    However, if you would like to explore this topic further you are welcome to conduct a full run-through of Assessment #4.
                </p>
            }
            {((state.CurrentAssessementStepIndex == OverallAssessmentStepsEnum.Assessment4Results
              || state.CurrentAssessementStepIndex == OverallAssessmentStepsEnum.ResultsOverview)
                &&
                (state.OverallAssessmentFuelTypesStatus.checkAgenciesCollectDataEveryClientFlag !== "Y"
                || state.OverallAssessmentFuelTypesStatus.checkVendorsSupplyDataEveryClientFlag !== "Y"
                || state.OverallAssessmentFuelTypesStatus.checksIdenfityErrorsFlag !== "Y"
                || state.OverallAssessmentFuelTypesStatus.processReviewFindingsFlag !== "Y"
                || state.OverallAssessmentFuelTypesStatus.processReviewChecksFlag !== "Y"))
                &&
                <p>
                <strong>Potential issue present! Follow-up required!</strong><br/>
                Please conduct a full run-through of Assessment #4 to learn more about this potential issue and ways you can address it.
            </p>
            }
        </div>
        }

        <br/>
        <button className="dataButton"
            onClick={() => state.overallAssessmentShowPreviousStep()}>
            Previous
        </button>
        {state.CurrentAssessementStepIndex < OverallAssessmentStepsEnum.ResultsOverview
        &&
            <button className="dataButton"
                onClick={() => state.overallAssessmentShowNextStep()}
                disabled={state.OverallAssessmentShowNextStepDisabled === true}>
                Next
            </button>
        }
        <br/>
        <button className="dataButton"
            onClick={() => state.backToStart()}>
            {state.CurrentAssessementStepIndex < OverallAssessmentStepsEnum.ResultsOverview
              &&<React.Fragment>Back to start</React.Fragment>}
              {state.CurrentAssessementStepIndex === OverallAssessmentStepsEnum.ResultsOverview
              &&<React.Fragment>Finish &amp; Save</React.Fragment>}
        </button>
        {state.CurrentAssessementStepIndex === OverallAssessmentStepsEnum.ResultsOverview
        &&
            <button className="dataButton"
                onClick={() => window.print()}>
                Print
            </button>
        }

        <div style={{clear:"both"}}>&nbsp;</div>
    </div>
);

export default OverallAssessment;
